import React from 'react'
import { cm } from '~/utils/utils'

export interface SettingsSectionProps {
  children: React.ReactNode
  className?: string
}

export function SettingsSection({ children, className }: SettingsSectionProps) {
  return (
    <div
      className={cm(
        'bg-tokens-neutral-fill-fill-1 rounded-3xl px-6 py-4 flex flex-col gap-2',
        className
      )}
    >
      {children}
    </div>
  )
}
